export interface TitleEventDetail {
  title: string;
}

export default class TitleDispatcher {
  static EVENT_TYPE = 'title-change';

  static dispatch(title: string) {
    window.dispatchEvent(new CustomEvent<TitleEventDetail>(TitleDispatcher.EVENT_TYPE, { detail: { title } }));
  }
}
